module.exports = __webpack_public_path__ + "static/media/hero-ve-bg.33d42a30.svg";